export const en = {
    rules: {
        list: {
            type: "Type",
            description: "Description",
            name: "Name",
            entity: "Entity",
            status: "Status"
        },
        alerts: {
            create: {
                title: "Create Rule",
                text: "Are you sure you want to create <b>%{rule}</b>",
                success: {
                    title: "Rule Created Successfully",
                    text: "<b>%{rule}</b> was created successfully",
                },
                error: {
                    title: "Rule Create Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            delete: {
                title: "Delete Rule",
                text: "Are you sure you want to delete <b>%{rule}</b>",
                success: {
                    title: "Rule Deleted Successfully",
                    text: "You will now be redirected to the rules page",
                },
                error: {
                    title: "Rule Delete Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            edit: {
                title: "Edit Rule",
                text: "Are you sure you want to edit <b>%{rule}</b>",
                success: {
                    title: "Rule Edited Successfully",
                    text: "<b>%{rule}</b> was edited successfully",
                },
                error: {
                    title: "Rule Edit Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        form: {
            headers: {
                create: "Create Rule",
                edit: "Edit Rule",
                view: "View Rule"
            },
            name: {
                label: "Name",
            },
            entity: {
                label: "Entity",
            },
            type: {
                label: "Type",
            },
            description: {
                label: "Description"
            },
            status: {
                label: "Status",
                enabled: "Enabled",
                disabled: "Disabled"
            },
            permissions: "Permissions"
        },
        search: {
            name: "Name",
            type: "Type",
            description: "Description",
            status: "Status",
            entity: "Entity"
        },
        permissions: {
            RULES: "Rules",
            CREATE_RULE: "Create rules",
            READ_RULE: "Read rules",
            UPDATE_RULE: "Update rules",
            DELETE_RULE:"Delete rules"
        }
    },
    root: {
        permissions: {
            ROOT: "Root",
        }
    }
};